import React from "react";

import Grid from "@mui/material/Grid";
import { CustomEventElements } from "@src/features/customEvents/components/CustomEventElements";
import { CustomEventPageTargetingWrapper } from "@src/features/customEvents/components/CustomEventPageTargetingWrapper";

interface ElementViewedProps {
  isArchived: boolean;
}

export const ElementViewed = ({ isArchived }: ElementViewedProps) => {
  return (
    <Grid container width={"100%"}>
      <CustomEventElements isArchived={isArchived} />
      <Grid marginTop={"20px"} width={"100%"}>
        <CustomEventPageTargetingWrapper
          buttonText={"Add a Page"}
          showHeader
          isArchived={isArchived}
        />
      </Grid>
    </Grid>
  );
};
